import { useCallback, useMemo } from 'react';

import type { OptLogVolumeActions } from '~/shared/types/api';
import {
  getOptLogActionRowHeight,
  getOptLogActionTableLayoutSignature,
  type OptLogActionTableLayoutRow,
} from '~/shared/utils/optLogActionUtils';

export type OptLogActionsTableRow = OptLogVolumeActions & { _isSkeleton?: boolean };

export function useOptLogActionsTableGridProps(rowData: OptLogActionsTableRow[]) {
  const rowLayoutSignature = useMemo(
    () => getOptLogActionTableLayoutSignature(rowData),
    [rowData]
  );

  const getRowHeightForData = useCallback(
    (row: OptLogActionTableLayoutRow) => getOptLogActionRowHeight(row),
    []
  );

  return {
    themeClassName: 'ag-grid-auto-height-rows',
    rowLayoutSignature,
    fitColumnsToGrid: false as const,
    getRowHeightForData,
  };
}
